import { useEffect, useState } from 'react';

import viewProviders from '@/shared/api/shipping/providers/viewProviders';
import useRedirectLogin from '@/shared/hooks/useRedirectLogin';
import ShippingProvider from '@/shared/types/shipping/shippingProvider.type';

const useFetchShippingProviders = () => {
  const redirectLogin = useRedirectLogin();

  const [shippingProviders, setShippingProviders] = useState<
    ShippingProvider[] | null
  >(null);

  useEffect(() => {
    const fetchShippingProviders = async () => {
      const response = await viewProviders({
        body: {},
        onUnauthorized: redirectLogin,
      });

      if (response.success) {
        setShippingProviders(response.data);
      }
    };

    void fetchShippingProviders();
  }, [redirectLogin]);

  return { shippingProviders };
};

export default useFetchShippingProviders;
